import React from 'react';

import './List.css';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import CheckBox from '../forms/CheckBox';

class List extends React.Component {
  createItemBase(data, children, injectKey) {
    const { key, checkbox } = data;

    const keyAttribute = injectKey ? {
      key,
    } : {};

    let checkboxElement;
    if (checkbox !== undefined) {
      checkboxElement = (
        <CheckBox {...checkbox} />
      );
    }

    return (
      <div className="list-item" {...keyAttribute}>
        {checkboxElement}
        <div className="list-item-content">
          {React.cloneElement(children, data)}
        </div>
      </div>
    );
  }

  createItem(data, children, source) {
    const { key, link, checkbox } = data;

    const baseItem = this.createItemBase(data, children, link !== undefined && checkbox !== undefined);

    if (link !== undefined) {
      return (
        <Link className="list-item-wrapper" to={source === undefined ? link : (`${link}/${source}`)} key={key}>
          {baseItem}
        </Link>
      );
    } if (checkbox !== undefined) {
      return (
        <label className="list-item-wrapper" key={key}>
          {baseItem}
        </label>
      );
    }

    return baseItem;
  }

  render() {
    const {
      title, data, children, topLine = true, separator = true, sectionName, translate, source, hasDestinationData,
    } = this.props;
    React.Children.only(children);
    const attributes = {
      className: `list${!topLine ? ' list-no-top-line' : ''}${!separator ? ' list-no-separator' : ''}`,
    };

    return (
      <div className="list-parent">
        {title ? <h1>{title}</h1> : null}
        {this.renderHomepageDeviationHeaders(sectionName, translate)}
        <div {...attributes}>
          {data.map((data, i) => this.createItem({ ...{ key: i }, ...data }, children, source))}
          {data.length === 0
                        && <div>{hasDestinationData !== undefined ? (hasDestinationData === true ? translate('destination.loading_destination') : translate('destination.no_destinations')) : translate('destination.loading_destination')}</div>}
        </div>
      </div>
    );
  }

  renderHomepageDeviationHeaders(sectionName, translate) {
    if (sectionName === 'home') {
      return (
        <div className="header-div">
          <span className="header-company-name">
            {' '}
            <h4>
              {' '}
              {translate('destination.company_name')}
              {' '}
            </h4>
            {' '}
          </span>
          <span className="header-customer">
            {' '}
            <h4>
              {' '}
              {translate('destination.customer')}
              {' '}
            </h4>
            {' '}
          </span>
          <span className="header-destination-address">
            {' '}
            <h4>
              {' '}
              { translate('destination.destination_address') }
              {' '}
            </h4>
            {' '}
          </span>
          <span className="header-deviations">
            {' '}
            <h4>
              {' '}
              { translate('destination.deviations') }
              {' '}
            </h4>
            {' '}
          </span>
        </div>
      );
    }
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const hasLanguages = Array.isArray(locale.languages) && locale.languages.length > 0;

  return {
    translate: hasLanguages ? getTranslate(locale) : () => '',
  };
};

export default connect(
  mapStateToProps,
  null,
)(List);
